import {routes} from './revista.routes';
import RevistaListController from "./directory/directory.controller";
import RevistaService from "./revista.service";
import RevistaDetailsController from "./details/details.controller";
import RevistaCreateRevistaController from "./new/new.controller";

export default angular.module('app.revista', [])
  .config(routes)
  .controller('RevistaListController', RevistaListController)
  .service('RevistaService', RevistaService)
  .controller('RevistaDetailsController', RevistaDetailsController)
  .controller('RevistaCreateRevistaController', RevistaCreateRevistaController)
  .name;
